import React, { useState, useEffect } from "react";
import Images from "../../ALL_Images/Images.js";
import Searchbox from "../Searchbox_component/Searchbox";
import "../HowItWorks_components/how.css";
import "./portfolio.css";
import Whatsapp from "../Whatsapp";
import CallbackPopup from "../../mainUtils/CallbackPopup";
import BackToTop from "../BackToTop";
import PortfolioNav from "./PortfolioNav";
import { CgMenu } from "react-icons/cg";
import ImgGallery from "./ImgGallery";
import { useLocation } from "react-router";
export default function Portfolio() {
  const location = useLocation();
  const [imgPack, setimgPack] = useState();

  const getImagePack = (imgs) => {
    setimgPack(imgs);
  };
  useEffect(() => {
    const title = document.querySelector("title");
    title.innerText = `Amazing photoshoot portfolio by Fodrixographer | Fodrix`;

    const desc = document.querySelector("meta[name='description']");
    desc.setAttribute(
      "content",
      "Fodrix helps you to get an amazing photoshoot experience for Travel, wedding, Pre-wedding and all types of events at an affordable price anywhere in India."
    );

    const canonical = document.querySelector("link[rel='canonical']");
    canonical.setAttribute("href", "https://www.fodrix.com/portfolio");
  }, []);
  return (
    <>
      <div className="portfolio_container">
        <PortfolioNav getImagePack={getImagePack} />
        <div className="image_gallery_container">
          <Whatsapp />
          <h1 className="portfolio-header" id="travel">
            {imgPack || "Travel"}
          </h1>
          <div class="main_container_pf">
            <ImgGallery packImg={imgPack} />
          </div>

          {/* <Searchbox /> */}
          <CallbackPopup popup={true} callBackForm={true} />
          <div className="search_heading">
            <h3>Get an awesome photoshoot experience!</h3>
          </div>
          <div className="search_how">
            <Searchbox />
          </div>
        </div>
      </div>
    </>
  );
}
